import React, { useCallback } from "react";
import { createPortal } from "react-dom";
import "../../Dialog/DialogAnimations.css";
import EventBus, { EventBusValues } from "../../../utils/EventBus";
import image from "../../../assets/images&icons/whatsnew-bg.svg";
import IntuitiveStreamlinedMenu from "../../../assets/images&icons/IntuitiveStreamlinedMenu.png";
import FasterLoadTimes from "../../../assets/images&icons/FasterLoadTimes.png";
import OptimizedTodayLimitlessTomorrow from "../../../assets/images&icons/OptimzedTodayLimtlessTomorrow.svg";
import { Link } from "react-router-dom";
import TwoFactorAuthentication from "../../../assets/images&icons/2fa-example.jpg";
import ChevronRight from "../../Atomos/Icons/ChevronRight";
import SSOexample from "../../../assets/images&icons/SSOexample.png";
import LogoFooter from "../../../assets/images&icons/logo-footer-escaled.svg";
import MyWSGRedesign from "../../../assets/images&icons/mywsg.png";
export function CustomWhatsNewDialog() {
  const SQUARED_TILE_DATA = [
    {
      title: "Stronger Security With",
      boldText: "Two-Factor Authentication",
      image: TwoFactorAuthentication,
      alt: "Stronger security with Two-Factor Authentication",
    },
    {
      title: "Quick Access Through",
      boldText: "Single Sign-On",
      image: SSOexample,
      alt: "Quick Access Through Single Sign-On",
    },
    {
      title: "Intuitive Design",
      boldText: "My WSG Page",
      image: MyWSGRedesign,
      alt: "Redesigned MY WSG",
    },
    {
      title: "Intuitive And Streamlined",
      boldText: "Menu",
      image: IntuitiveStreamlinedMenu,
      alt: "Intuitive and Streamlined Menu",
    },
  ] as const;

  const onClose = useCallback(() => {
    EventBus.dispatch(EventBusValues.CloseAllDialogs);
  }, []);

  return createPortal(
    <>
      <div
        className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 backdrop-blur-[8px] z-[9999] animate-[fadeIn_0.3s_ease-out] items-center align-middle justify-center cursor-default"
        onClick={onClose}
      />

      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-[0_20px_40px_rgba(0,0,0,0.15)] z-[10000] 
        max-w-[calc(100vw-32px)] h-[70vh] md:h-[85vh] lg:h-[95vh] flex flex-col min-h-[350px] outline-none cursor-default animate-[slideIn_0.3s_ease-out] overflow-x-hidden w-[calc(100vw-32px)] 
        sm:w-[calc(100vw-80px)] md:w-[600px] lg:w-[600px] xl:w-[600px] 2xl:w-[600px]"
        tabIndex={-1}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            onClose();
          }
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="w-full h-16 sm:h-20 md:h-22 bg-[#444444] after:bg-contain after:bg-repeat-x flex flex-row justify-between sticky top-0 flex-shrink-0"
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: "50%",
            backgroundRepeat: "",
          }}
        >
          <div className="ml-3 md:ml-6 flex flex-col items-start justify-center flex-1">
            <h2 className="text-white text-lg sm:text-2xl md:text-[27px] font-decimal leading-tight">
              WSG Next Generation Platform
            </h2>
          </div>

          <button
            className="text-white border-none text-md md:text-lg cursor-pointer w-8 h-8 flex items-center justify-center rounded-full transition-all 
            duration-200 ease-in-out hover:bg-gray-100 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-sans"
            onClick={onClose}
          >
            &#10005;
          </button>
        </div>

        <div className="flex-shrink-0">
          <Link to="/whats-new" onClick={onClose}>
            <div
              className="flex flex-row gap-x-2 bg-gradient-to-r from-[#8B3730] to-[#E15142] w-[40%] sm:w-[35%] md:w-[32%] lg:w-[30%] xl:w-[28%] 2xl:w-[25%] 
            min-w-[120px] h-8 sm:h-9 md:h-10 ml-auto rounded-bl-3xl text-white font-bold text-xs sm:text-sm md:text-base items-center justify-center font-sans px-2 sm:px-3 md:px-4"
            >
              <span className="whitespace-nowrap">LEARN MORE</span>
              <div className="w-3 h-3 sm:w-4 sm:h-4 bg-white rounded-full flex items-center justify-center text-[#0070CD] flex-shrink-0">
                <ChevronRight style={{ marginLeft: "1px" }} />
              </div>
            </div>
          </Link>
        </div>

        <div className="flex-shrink-0 py-2">
          <h2 className="text-[#9f3022] text-base sm:text-lg md:text-xl lg:text-2xl font-extrabold font-sans text-center leading-tight px-2">
            Check Out Our Latest Enhancements!
          </h2>
        </div>

        <div className="px-12 flex-1 overflow-hidden grid grid-cols-2 grid-rows-2 gap-3 md:gap-4 min-h-0">
          {SQUARED_TILE_DATA.map((item, index) => (
            <div
              key={index}
              className="bg-[#f1f1ef] p-4 rounded-xl flex flex-col items-center justify-between overflow-hidden min-h-0 gap-2"
            >
              <h3 className="text-[#004680] font-sans text-xs sm:text-sm md:text-base text-center leading-tight flex-shrink-0">
                {item.title} <br />
                <span className="font-bold">{item.boldText}</span>
              </h3>
              <img
                className="w-full h-full flex-1 object-contain min-h-0"
                src={item.image}
                alt={item.alt}
              />
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 mx-auto my-2 sm:my-3 md:my-4 px-2 sm:px-3 md:px-0 flex-shrink-0">
          <div className="flex justify-center">
            <img
              src={LogoFooter}
              alt="Dialog Background"
              className="object-contain w-[100px] sm:w-[120px] md:w-[140px] lg:w-[160px]"
            />
          </div>
          <div className="flex justify-center w-full sm:w-auto">
            <img
              src={OptimizedTodayLimitlessTomorrow}
              alt="Dialog Background"
              className="object-contain w-full max-w-[150px] sm:max-w-[250px] md:max-w-[300px] lg:max-w-[350px]"
            />
          </div>
        </div>
      </div>
    </>,
    document.body
  );
}
